import Layout from '@/components/Layout';
import ResourceCard from '@/components/ResourceCard';
import {
  ResourceType,
  AudienceType,
  FocusType,
} from '@/components/ResourcesFilterBar';
import ResourcesGrid from '@/components/ResourcesGrid';
import { SectionHeader } from '@/components/SectionHeader';
import { ContentfulBlogPost as BaseBlogPost } from '@/utils/types';
import { Flex, Box } from '@everlywell/ui-kit';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

interface ContentfulBlogPost extends BaseBlogPost {
  contentType?: ResourceType | string;
  audience?: AudienceType;
  focus?: FocusType;
  ctaText?: string;
}

interface LatestBlogPostQueryResult {
  allContentfulBlogPost: {
    nodes: Array<ContentfulBlogPost>;
  };
}

const LATEST_POST_QUERY = graphql`
  query LatestBlogPostQuery {
    allContentfulBlogPost(sort: { publishDate: DESC }, limit: 1) {
      nodes {
        id
        title
        slug
        contentType
        audience
        focus
        publishDate
        headerContent {
          headerContent
        }
        pdfAttachment {
          url
          title
          description
        }
        featuredImage {
          gatsbyImageData(
            width: 600
            height: 400
            placeholder: BLURRED
            formats: [AUTO, WEBP]
            layout: CONSTRAINED
          )
          title
          description
        }
      }
    }
  }
`;

const IndexPage = () => {
  const data = useStaticQuery<LatestBlogPostQueryResult>(LATEST_POST_QUERY);
  const latestPost = data.allContentfulBlogPost.nodes[0];

  return (
    <Layout>
      <Box
        as="section"
        bgColor="#EFF9F5"
        paddingTop={['6rem', '6rem', '7rem']}
        paddingX={['20px', '20px', '60px']}
        paddingBottom={['3rem', '3rem', '4rem']}
      >
        <Flex
          maxWidth="1440px"
          bgColor="#EFF9F5"
          width="100%"
          margin="0 auto"
          direction={['column', 'column', 'row']}
          justifyContent="space-around"
          alignItems={['center', 'center', 'center']}
          gap={[6, 12, 16]}
        >
          <Box maxWidth="600px" mx={['auto', 'auto', '0']}>
            <SectionHeader
              eyebrow="Resources"
              title="Your health hub: Expert resources & insight"
              align="left"
              titleMaxWidth="600px"
              cta={{
                text: 'Discover & Learn',
                link: '#blog-list',
              }}
            />
          </Box>

          {latestPost && (
            <Box
              maxWidth={['350px', '350px', '420px']}
              width="100%"
              position="relative"
              mx={['auto', 'auto', '0']}
              mt={['25px', '25px', 0]}
              display={['none', 'none', 'block']}
            >
              <Box
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                width="115%"
                height={0}
                paddingBottom="115%"
                bgColor="#A1DEC1"
                rounded="full"
                zIndex={0}
              />
              <Box position="relative" zIndex={1}>
                <ResourceCard shadow={true} resource={latestPost} />
              </Box>
            </Box>
          )}
        </Flex>
      </Box>

      <Box id="blog-list">
        <ResourcesGrid />
      </Box>
    </Layout>
  );
};

export default IndexPage;
